import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserAdvancedInfos } from "../../Core/Api/Types/user-advanced-infos";
import { RootState } from "../redux-store";

export interface ReduxStateSettingsUsers {
  usersList: UserAdvancedInfos[];
  sidebarOpen: boolean;
  settingsExpanded: boolean;
  expandedSections: string[];
}

const initialState: ReduxStateSettingsUsers = {
  usersList: [],
  sidebarOpen: true,
  settingsExpanded: false,
  expandedSections: [],
};

export const settingsUsersSlice = createSlice({
  name: "settingsUsers",
  initialState,
  reducers: {
    SetUsersList: (state, action) => {
      state.usersList = action.payload;
      console.debug("users:SetUsersList() ok");
    },
    ToggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    ToggleSettingsExpanded: (state) => {
      state.settingsExpanded = !state.settingsExpanded;
    },
    ToggleSection: (state, action) => {
      if (state.expandedSections.includes(action.payload)) {
        state.expandedSections = state.expandedSections.filter((x) => x !== action.payload);
      } else {
        state.expandedSections = [...state.expandedSections, action.payload];
      }
    },
    SetSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
  },
});

export const { SetUsersList, ToggleSidebar, ToggleSettingsExpanded, ToggleSection, SetSidebarOpen } =
  settingsUsersSlice.actions;

export const GetUsersList = (state: RootState): UserAdvancedInfos[] => state.settingsUsersSlice.usersList || [];
export const GetSidebarOpen = (state: RootState): boolean => state.settingsUsersSlice.sidebarOpen;
export const GetSettingsExpanded = (state: RootState): boolean => state.settingsUsersSlice.settingsExpanded;

export const GetSectionExpanded = (state: RootState): string[] => state.settingsUsersSlice.expandedSections;

export default settingsUsersSlice.reducer;
